"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.aes256cbc = exports.aes256gcm = void 0;
var compat_1 = require("../_node/compat");
var aes256gcm = function (key, nonce, AAD) {
    return (0, compat_1._compat)("aes-256-gcm", key, nonce, AAD);
};
exports.aes256gcm = aes256gcm;
var aes256cbc = function (key, nonce, AAD) {
    return (0, compat_1._compat)("aes-256-cbc", key, nonce);
};
exports.aes256cbc = aes256cbc;
